export const DEALERSHIP_PLACEHOLDER = 'Select';
export const FETCH_DEALERSHIPS_FAILURE_MESSAGE = 'Fetch Dealerships Failure';
export const ERROR = 'error';
